export default __webpack_public_path__ + "static/media/RossBassett.fcf96961.png";